import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  mutation VerifyToken($token: String!) {\n    tokenVerify(token: $token) {\n      payload\n      user {\n        ...User\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  mutation TokenAuth($email: String!, $password: String!) {\n    tokenCreate(email: $email, password: $password) {\n      token\n      errors {\n        field\n        message\n      }\n      user {\n        ...User\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { userFragment } from "../fragments/auth";
export var tokenAuthMutation = gql(_templateObject(), userFragment);
export var tokenVeryficationMutation = gql(_templateObject2(), userFragment);